import { STEP_TOC_UPDATED_EVENT, StepTocStructure } from "./models";

/**
 * Extension events related to step table of contents
 */
export enum StepTocEvent {
  /**
   * Event emitted when the table of contents is updated
   */
  TOC_UPDATED = "step-toc-updated",

  /**
   * Event emitted when a step selection is requested
   */
  SELECT_STEP = "step-toc-select-step",
}

/**
 * Creates and dispatches a custom event when the step TOC structure is updated
 * @param structure - The updated table of contents structure
 */
export function dispatchTocUpdatedEvent(structure: StepTocStructure): void {
  const event = new CustomEvent(STEP_TOC_UPDATED_EVENT, {
    detail: { structure },
    bubbles: true,
  });

  document.dispatchEvent(event);
}

/**
 * Creates and dispatches a custom event to select a specific step
 * @param stepId - ID of the step to select
 */
export function dispatchSelectStepEvent(stepId: string): void {
  const event = new CustomEvent(StepTocEvent.SELECT_STEP, {
    detail: { stepId },
    bubbles: true,
  });

  document.dispatchEvent(event);
}
